import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StreAppPaymentDialogData } from './streapp-payment-dialog-data.model';
import { ageRequirement } from 'src/app/constants/ageRequirement';

@Component({
    selector: 'app-streapp-payment-dialog',
    templateUrl: './streapp-payment-dialog.component.html',
    styleUrl: './streapp-payment-dialog.component.scss',
    standalone: false
})
export class StreappPaymentDialogComponent implements OnInit{
  isCreatorUnderage: boolean | null = null;

  ageReq: number = ageRequirement;

  constructor(
    private readonly dialogRef: MatDialogRef<StreappPaymentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: StreAppPaymentDialogData) {}
    
    ngOnInit(): void {
      this.isCreatorUnderage = this.data.isCreatorUnderage;
    }
  

    closeWithConfirm(): void {
      this.dialogRef.close(true);
    }
  
    close() : void {
      this.dialogRef.close(false);
    }
}
